"use client";

import { useMemo } from "react";

import { ListingStatus } from "@/.zenstack/logical-prisma-client";
import BaseListingCarousel from "@/components/listing-carousels/BaseListingCarousel";
import { useListings } from "@/hooks/use-listings";
import { useSession } from "@/lib/auth/client";

export default function BiddingCarousel() {
  const { data: session, isPending } = useSession();

  // Fetch listings that the user has bid on
  const { data: listings, isLoading } = useListings({
    biddedByUserId: session?.user?.id || "",
    bidTimeFilter: "current", // Only show current auctions (not ended)
    pageSize: 4,
  });

  // Filter to only show listings with active auctions
  const activeBiddingListings = useMemo(() => {
    if (!session?.user?.id) return [];

    const now = new Date();
    return listings?.filter((listing) => {
      if (!listing) return false;

      // Must be active listing
      if (listing.status !== ListingStatus.ACTIVE) return false;

      // Must have an auction that hasn't ended
      const endDate = listing.atAuction?.auctionEndDate;
      if (!endDate) return false;

      return new Date(endDate) > now;
    });
  }, [listings, session?.user?.id]);

  // Only show for authenticated users
  if (!session?.user || isPending) {
    return null;
  }

  return (
    <BaseListingCarousel
      heading="Your Active Bids"
      listings={activeBiddingListings}
      isLoading={isLoading}
      emptyMessage="You haven't bid on any active listings yet."
      delayTime={10000} // Auto-advance every 10 seconds
    />
  );
}
